import { Link } from 'react-router-dom';
import React from 'react';
import cx from 'classnames';
import ButtonLinksProps from '../../types/ButtonLinksProps';
import style from './Button.module.css';

/**
 * ### Button component with a link to it.
 *
 * The css property displays a fontawesome icon. Note that you need to create the css rule for that.
 *
 * @param {string} icon - The css class to use.
 * @param {string} link - The link (url) to use.
 * @param {string} children - The content to display.
 * @returns
 */
function ButtonLink({ children, link, icon }: ButtonLinksProps) {
  return (
    <Link
      data-testid={`${link}-${icon}`}
      to={link}
      className={cx(style.btn, icon)}
      data-icon={icon}
    >
      <span>{children}</span>
    </Link>
  );
}

export default ButtonLink;
